import React from 'react';

import config from '../config';

import logo from '../assets/logos/logo.svg';

import './Footer.css';

const Footer = () => (
  <div className="Footer">
    <div className="bottom-icontext">
      <p>Powered by</p>
      <a href="https://mhub.my/" target="_blank" rel="noopener noreferrer">
        <img
          alt="MHub"
          src={logo}
        />
      </a>
    </div>

    <div className="version">
      <p>v{config.app.version}</p>
    </div>

  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx